const privacyConfig = {
    public:1,
    private:2,
    Private_except:3,
}

export default privacyConfig